
export const GEOIDInfo = [
    {
        "label": "None",
        "value": "None"
    },
    {
        "label": "ellipsoid",
        "value": "ellipsoid"
    },
    {
        "label": "GEOID18",
        "value": "GEOID18"
    },
    {
        "label": "GEOID12B",
        "value": "GEOID12B"
    },
    {
        "label": "GEOID12A",
        "value": "GEOID12A"
    },
    {
        "label": "GEOID12",
        "value": "GEOID12"
    },
    {
        "label": "GEOID09",
        "value": "GEOID09"
    },
    {
        "label": "GEOID03",
        "value": "GEOID03"
    },
    {
        "label": "GEOID06",
        "value": "GEOID06"
    },
    {
        "label": "GEOID99",
        "value": "GEOID99"
    },
    {
        "label": "GEOID96",
        "value": "GEOID96"
    }
]